import { InlineHelp } from './InlineHelp'
import { useState } from 'react'
import { levelFor, levelXp } from '../../domain/area'
import type { Specialization } from '../../domain/specialization'
import { AddIcon, ExpandIcon, TuneIcon } from './Icons'
import { useI18n } from '../../i18n'

interface Props {
  specializations: Specialization[]
  selectedIds: Set<string>
  color: string
  onToggle: (id: string) => void
  onClear: () => void
  onManage: () => void
}

export const SpecializationProgressCard = ({ specializations, selectedIds, color, onToggle, onClear, onManage }: Props) => {
  const { copy: { common, skillProgress } } = useI18n()
  const [expanded, setExpanded] = useState(false)
  const visible = expanded ? specializations : specializations.slice(0, 4)
  const helper = specializations.length === 0
    ? skillProgress.addHelp
    : selectedIds.size === 0
      ? skillProgress.filterHelp
      : `${selectedIds.size} ${skillProgress.selected}`

  return (
    <section className="detail-card specialization-progress">
      <div className="specialization-progress__heading">
        <div><p className="eyebrow">{skillProgress.title}</p>{selectedIds.size > 0 ? <span>{helper}</span> : <InlineHelp topic="stats" text={helper} />}</div>
        <div>
          {selectedIds.size > 0 && <button className="text-button" type="button" onClick={onClear}>{common.all}</button>}
          <button className="icon-button" type="button" onClick={onManage} aria-label={skillProgress.manage}><TuneIcon /></button>
        </div>
      </div>
      {specializations.length === 0 ? (
        <button className="specialization-create" type="button" onClick={onManage}><AddIcon />{skillProgress.create}</button>
      ) : visible.map((item) => {
        const selected = selectedIds.has(item.id)
        return (
          <button key={item.id} className={selected ? 'specialization-row specialization-row--selected' : 'specialization-row'} type="button" aria-pressed={selected} onClick={() => onToggle(item.id)} style={{ '--specialization-color': color } as React.CSSProperties}>
            <span><strong>{item.name}</strong><small>Lvl. {levelFor(item.xp)}</small></span>
            <span className="xp-track"><i style={{ width: `${levelXp(item.xp) / 10}%`, backgroundColor: color }} /></span>
          </button>
        )
      })}
      {specializations.length > 4 && <button className="specialization-expand" type="button" aria-expanded={expanded} onClick={() => setExpanded((value) => !value)}>{expanded ? skillProgress.showLess : `${skillProgress.showAll} (${specializations.length})`}<ExpandIcon /></button>}
    </section>
  )
}
